import React from 'react';
import { createRoot } from 'react-dom/client';

import EmployeeApp from './EmployeeApp';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(<EmployeeApp />);
